import { getTeamChartWithTeamidAndChartid } from 'api/cloudApiGenerated';
import api from 'utils/ajax';
import { createAggregatedOptions, loadData } from './ChartHelper';

const payload = {
  metadata: {
    formId: 'default',
    formData: {
      title: 'Template Instance_News @10_null_01Fr',
      mediaCreatedOn: '2020-11-16T12:55:01.000Z',
      description: '',
      createdOn: '2023-01-20T09:43:21.281Z',
      config_conformKeldaId: '',
      config_conformExportFormat: '',
      config_archiveCopyAutoConform: '',
      config_archiveCopyTracksToMute: ''
    }
  },
  itemType: 'video',
  itemState: 'complete',
  transcriptionState: 'complete',
  ingest: {
    source: {
      path: '3735da01-69d5-4117-a577-34bc88359e1e',
      scheme: 'managed-storage',
      realm: 'mb10-mimir-prods-incoming-media'
    }
  },
  editProxyAvailable: true,
  mediaSize: 618980,
  modifiedOn: '2023-01-20T09:44:32.883Z',
  transcodingState: 'complete',
  visibleTo: {
    level: 'tenant',
    groups: [],
    users: []
  },
  id: '3735da01-69d5-4117-a577-34bc88359e1e',
  folderParents: ['8d5e3234-b443-4b63-8d3d-eff6593041c9'],
  originalFileName: 'pexels-stefano-barbieri-5899075.mp4',
  hasProxy: true,
  mediaType: 'video/mp4',
  proxySize: 3707550,
  frameCount: 297,
  uploadProgressInfo: {
    bytes: {
      known: 618980,
      done: 618980
    },
    files: {
      known: 1,
      done: 1
    }
  },
  createdBy: '7d80f6ae-41c6-4392-a9d8-998bb2551575',
  editProxyFormat: 'h264',
  mediaDuration: 9909.9,
  progressInfo: {
    percentage: 0,
    description: 'Web proxy generation is in progress',
    errors: [],
    status: 'Transcoding (Web)'
  },
  mediaFrameRate: 29.97,
  thumbnailInfo: {
    type: 'mxcoder'
  },
  hasEditProxy: true,
  thumbnail: 'ptothumb',
  thumbnailStrip: 'asd',
  proxy: 'asd',
  vttUrl: '',
  loading: false,
  title: 'Template Instance_News @10_null_01Fr',
  description: '',
  itemCreatedOn: '2023-01-20T09:43:21.281Z',
  mediaRecordedOn: '2020-11-16T12:55:01.000Z',
  provider: 'Mimir',
  self: 'https://mimir.mjoll.no/api/v1/items/3735da01-69d5-4117-a577-34bc88359e1e'
};

const downloadVideo = (aggregatedOptions, { uuid }) => {
  api.ajax({
    type: 'post',
    url: 'http://127.0.0.1:3001/export',
    data: {
      options: JSON.stringify(aggregatedOptions),
      type: 'video/quicktime',
      constr: 'chart',
      projectType: 'chart',
      cssModules: JSON.stringify([]),
      pluginConfig: JSON.stringify({}),
      name: uuid,
      synchronous: true
    }
  });
};

const generateProjectConfig = (response) => {
  const { data, details } = response;

  const chartOptions = JSON.parse(data);
  const chartData = JSON.parse(details);

  chartOptions.settings.dataProvider = chartData;
  const customizedOptions = chartOptions.options;
  if (chartOptions?.settings?.dataProvider) {
    loadData(chartOptions, customizedOptions);
  }

  return createAggregatedOptions(
    { customizedOptions, templateOptions: chartOptions.templateOptions, themeOptions: chartOptions.themeOptions },
    { customCode: chartOptions }
  );
};

export const copyTextToClipboard = (text, noAlert) => {
  let textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();

  try {
    let successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    if (!noAlert) alert(successful ? 'Copied to clipboard!' : 'Something went wrong...');
  } catch (err) {
    document.body.removeChild(textArea);
  }
};

export const sendPayload = async (project, useLink) => {
  const { id: chartId, team_owner: teamId } = project;
  const response = await getTeamChartWithTeamidAndChartid(teamId, chartId);
  const { embedCode, thumbnail_url } = response;
  const iframe = embedCode;
  const thumbnail = thumbnail_url;
  //  const { aggregatedOptions } = generateProjectConfig(response);
  // downloadVideo(aggregatedOptions, response);

  console.log(iframe, thumbnail, /* aggregatedOptions*/ response.iframeURL, useLink);
  // parent.postMessage(payload, '*');

  console.log(useLink, useLink ? response.iframeURL : iframe);
  copyTextToClipboard(useLink ? response.iframeURL : iframe, true);
};
